export enum MailSearchType {
  SUBJECT = "subject",
  SENDER = "sender"
}
